// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 20", width: "20", height: "20" }, props),
        React.createElement(React.Fragment, null,
            React.createElement("path", { fill: "#F3F3F3", d: "M0 0H19V19H0V0Z" }),
            React.createElement("path", { fill: "#F35325", d: "M1 1H9V9H1V1Z" }),
            React.createElement("path", { fill: "#81BC06", d: "M10 1H18V9H10V1Z" }),
            React.createElement("path", { fill: "#05A6F0", d: "M1 10H9V18H1V10Z" }),
            React.createElement("path", { fill: "#FFBA08", d: "M10 10H18V18H10V10Z" }))));
};
Icon.displayName = 'MicrosoftLogo20x20';
export default Icon;
//# sourceMappingURL=MicrosoftLogo20x20.js.map